import Chartist from "chartist";
// import "chartist-plugin-accessibility";
import "chartist-plugin-tooltips";
import "chartist-plugin-legend";

const chart = {
    install(Vue: any, options: any = {}) {
        const defaultOptions = {messageNoData: "", classNoData: "ct-nodata"};
        options = Object.assign({}, defaultOptions, options);

        Vue.chartist = Chartist;
        Vue.prototype.$chartist = Chartist;

        Vue.component("chartist", {
            render(h: any) {
                return h("div", {
                    "ref": "chart",
                    "class": [
                        this.ratio,
                        {noData: this.noData},
                    ],
                    "v-text": this.message,
                });
            },
            mounted() {
                this.draw();
            },
            props: {
                ratio: {type: String},
                data: {type: Object},
                options: {type: Object},
                type: {
                    type: String, required: true, validator(val: any) {
                        return val === "Pie" || val === "Line" || val === "Bar";
                    },
                },
                eventHandlers: {type: Array},
                responsiveOptions: {type: Array},
            },
            data() {
                return {
                    chart: null,
                    error: {onError: false, message: ""},
                    noData: "",
                    message: "",
                    classNoData: options.classNoData,
                };
            },
            methods: {
                clear() {
                    this.noData = ""; // remove class ct-nodata
                    this.message = ""; // remove message no data
                    if (this.error.onError) { this.error = {onError: false, message: ""}; } // clear error
                },
                draw() {
                    if (this.haveNoData()) { return this.setNoData(); }
                    this.clear();
                    this.chart = new this.$chartist[this.type](this.$refs.chart, this.data, this.options, this.responsiveOptions);
                    this.setEventHandlers();
                },
                haveNoData() {
                    return !this.data ||
                        this.data.series.length < 1 ||
                        (
                            (this.type !== "Pie" && !this.options.distributeSeries) &&
                            (this.data.labels.length < 1 || this.data.series.every((serie: any) => {
                                if (Array.isArray(serie)) { return !serie.length; }
                                return !serie.data.length;
                            }))
                        );
                },
                redraw(newValue: any, oldValue: any) {
                    if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                        return;
                    }
                    if (this.error.onError) { return this.draw(); }
                    if (this.haveNoData()) { return this.setNoData(); }
                    this.clear();
                    this.chart.update(this.data, this.options);
                },
                resetEventHandlers(eventHandlers: any, oldEventHanlers: any) {
                    if (!this.chart) { return; }
                    for (const item of oldEventHanlers) {
                        this.chart.off(item.event, item.fn);
                    }
                    for (const item of eventHandlers) {
                        this.chart.on(item.event, item.fn);
                    }
                },
                setEventHandlers() {
                    if (this.eventHandlers) {
                        for (const item of this.eventHandlers) {
                            this.chart.on(item.event, item.fn);
                        }
                    }
                },
                setNoData() {
                    this.error = {onError: true, message: options.messageNoData};
                    this.noData = this.classNoData;
                    this.message = this.error.message;
                },
            } as any,
            watch: {
                ratio: "redraw",
                options: "redraw",
                data: {handler: "redraw", deep: true},
                type: "draw",
                eventHandlers: "resetEventHandlers",
            },
        });
    },
};

export { chart };



// WEBPACK FOOTER //
// ./src/scripts/components/vue-chartist.ts